import { useMutation, useQueryClient } from '@tanstack/react-query'

import { brandsApi } from '@/api/brands/brandsApi'
import { brandsQueries } from '@/api/brands/brandsQueries'

export const useDeleteBrandAliasMutation = (brandId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (aliasId: string) => brandsApi.deleteAlias(brandId, aliasId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: brandsQueries.aliases(brandId).queryKey,
      })
    },
  })
}
